import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/styles/auth/login.scss';
import logo from '../assets/img/logo.png';
import axios from './authInterceptor'; // Usar el interceptor personalizado

const Login = () => {
  const navigate = useNavigate();

  //Validaciones 
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const [errors, setErrors] = useState({
    username: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  

  const validate = () => {
    let valid = true;
    const newErrors = { username: '', password: '' };
    if (!formData.username) {
      newErrors.username = 'El usuario es obligatorio';
      valid = false;
    }
    // Validación de contraseña
    if (!formData.password) {
      newErrors.password = 'La contraseña es obligatoria';
      valid = false;
    } else if (formData.password.length < 6) {
      newErrors.password = 'Debe tener al menos 6 caracteres';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  // conexion con endpoint Login - usando la misma estructura que mensajes
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (validate()) {
      setIsLoading(true);
      setLoginError('');
      
      try {
        // Usar endpoint de NestJS
        const response = await axios.post('/api/auth/sign-in', {
          username: formData.username,
          password: formData.password
        }, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });

        console.log('Login response:', response.data);

        if (response.data.Status === "Success") {
          // Guardar token y datos del usuario
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('usuario', JSON.stringify(response.data.user));
          localStorage.setItem('isAuthenticated', 'true');
          
          console.log('[LOGIN] Usuario autenticado exitosamente:', response.data.user);
          
          if (response.data.requiresPasswordChange) {
            console.log('Usuario requiere cambio de contraseña, redirigiendo...');
            localStorage.setItem('requiresPasswordChange', 'true');
            navigate('/first-password-change');
          } else {
            console.log('Login completo, accediendo al dashboard...');
            localStorage.removeItem('requiresPasswordChange');
            navigate('/dashboard/resumen');
          }
        } else {
          setLoginError(response.data.Error || 'Error en el inicio de sesión');
        }
      } catch (error) {
        console.error('Error en el login:', error);
        
        if (error.response) {
          const errorData = error.response.data;
          const errorMessage = errorData?.message || errorData?.Error || 'Error del servidor';
          setLoginError(errorMessage);
        } else if (error.request) {
          setLoginError('Error de conexión. Verifica que el servidor esté ejecutándose.');
        } else {
          setLoginError('Error inesperado. Por favor, inténtalo de nuevo.');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.id]: '',
    });
    // Limpiar error de login cuando el usuario empiece a escribir
    if (loginError) {
      setLoginError('');
    }
  };

  return (
    <div className="loginContainer">
      <div className="loginBox">
        <img src={logo} alt="Logo" className="logo" />
        <h1 className="title">Bienvenido de nuevo</h1>
        <p className="subtitle">
          Ingresa tu usuario y contraseña para continuar
        </p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="inputGroup">
            <label htmlFor="username">Usuario/Correo</label>
            <input
              type="text"
              id="username"
              placeholder="Ingresa tu usuario o correo"
              value={formData.username}
              onChange={handleChange}
              disabled={isLoading}
            />
            {errors.username && <p className="errorText">{errors.username}</p>}
          </div>
          
          <div className="inputGroup passwordGroup">
            <label htmlFor="password">Contraseña</label>
            <div className="passwordInputWrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Ingresa tu contraseña"
                value={formData.password}
                onChange={handleChange}
                disabled={isLoading}
              />
              <button
                type="button"
                className="togglePasswordBtn"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
              >
                <i className={`ri-${showPassword ? 'eye-line' : 'eye-off-line'}`}></i>
              </button>
            </div>
            {errors.password && <p className="errorText">{errors.password}</p>}
          </div>

          <Link to="/ForgotPassword" className="forgotPassword">
            ¿Olvidaste tu contraseña?
          </Link>
          
          <hr className="divider" />
          
          {loginError && <p className="errorText">{loginError}</p>}
          
          <button type="submit" className="submitButton" disabled={isLoading}>
            {isLoading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
        </form>
        
        <div className="registerLink">
          <p>¿Necesitas ayuda? <Link to="/contact">Contacta al administrador</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
